import { render, staticRenderFns } from "./EmpresaListaDatosLaborales.vue?vue&type=template&id=6b219e08&scoped=true&"
import script from "./EmpresaListaDatosLaborales.vue?vue&type=script&lang=js&"
export * from "./EmpresaListaDatosLaborales.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaListaDatosLaborales.vue?vue&type=style&index=0&id=6b219e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b219e08",
  null
  
)

export default component.exports